import uniq from "lodash/uniq";
import recordQueryStringUsage from "views/logic/queries/recordQueryStringUsage";
import {
  addToQuery,
  formatValueForQuery,
  predicate,
  concatQueryStrings,
  edgeClause
} from "views/logic/queries/QueryHelper";
import { updateQueryString } from "views/logic/slices/viewSlice";
import { selectQueryString } from "views/logic/slices/viewSelectors";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
import { fieldValueOrClause } from "views/logic/valueactions/ValueActionQueryHelper";
const toPredicate = (field, value, type) => predicate(field, formatValueForQuery(value, type));
const formatNewQuery = (oldQuery, field, value, type) => addToQuery(oldQuery, toPredicate(field, value, type));
const orClause = (values) => `(${concatQueryStrings(
  values.map(({ field, value, type }) => toPredicate(field, value, type)),
  { operator: "OR", withBrackets: false }
)})`;
const valuesFromPath = (contexts) => contexts.valuePath.map((path) => {
  const [pathField, pathValue] = Object.entries(path)[0];
  return { field: pathField, value: pathValue, type: fieldTypeFor(pathField, contexts == null ? void 0 : contexts.fieldTypes) };
});
const valuesFromArray = (field, value, type) => value.map((arrayValue) => ({ field, value: arrayValue, type }));
const AddToQueryHandler = ({ queryId, field, value = "", type, contexts }) => async (dispatch, getState) => {
  const oldQuery = selectQueryString(queryId)(getState());
  const hasMultipleValuesInPath = hasMultipleValueForActions(contexts);
  const fieldValueIsArray = Array.isArray(value);
  const getValues = () => {
    if (hasMultipleValuesInPath) return valuesFromPath(contexts);
    if (fieldValueIsArray) return valuesFromArray(field, value, type);
    return [{ field, value, type }];
  };
  const valuesToAdd = uniq(getValues());
  let newQuery;
  const shouldAddValuePathWithOr = hasMultipleValuesInPath && (contexts == null ? void 0 : contexts.valuePathOperator) === "OR";
  const shouldAddArrayFieldValuesWithOr = !hasMultipleValuesInPath && fieldValueIsArray && valuesToAdd.length > 1;
  if (hasMultipleValuesInPath && (contexts == null ? void 0 : contexts.valuePathOperator) === "EDGE") {
    newQuery = addToQuery(
      oldQuery,
      edgeClause(
        { field: valuesToAdd[0].field, value: valuesToAdd[0].value },
        { field: valuesToAdd[1].field, value: valuesToAdd[1].value }
      )
    );
  } else if (shouldAddValuePathWithOr) {
    newQuery = addToQuery(oldQuery, orClause(valuesToAdd));
  } else if (shouldAddArrayFieldValuesWithOr) {
    newQuery = addToQuery(oldQuery, fieldValueOrClause(field, valuesToAdd));
  } else {
    newQuery = valuesToAdd.reduce(
      (prev, valueToAdd) => formatNewQuery(prev, valueToAdd.field, valueToAdd.value, valueToAdd.type),
      oldQuery
    );
  }
  await recordQueryStringUsage(newQuery, oldQuery);
  return dispatch(updateQueryString(queryId, newQuery));
};
export default AddToQueryHandler;
